import { Page } from '@/core/architecture'

import { PaymentDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * PaymentDetail Page
 * Implemented as a practical sample.
 */
export const PaymentDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <PaymentDetailTemplate state={state} {...actions} />
}
